"use client";
import React from "react";
import { Controller } from "react-hook-form";
import ErrorMessage from "@/components/shared/Form/ErrorMessage";
import { get } from "lodash";

interface InputProps {
  placeholder: string;
  name: any;
  control: any;
  errors: any;
  inputClassName?: string;
  wrapClassName?: string;
  subTitle?: string;
  rules?: any;
  [key: string]: any;
  image?: any;
}

const Input: React.FC<InputProps> = ({
  placeholder,
  name,
  control,
  errors,
  inputClassName,
  wrapClassName,
  subTitle,
  rules,
  image,
  characterLimit,
  ...props
}) => {
  const hasError = Boolean(get(errors, name));

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field }) => (
        <div
          data-field-name={name}
          className={`w-full rounded-xl border bg-[#fdfdfd] p-3 transition-all focus-within:bg-white focus-within:ring-2 ${
            hasError
              ? "border-red-400 bg-red-50/30 focus-within:border-red-500 focus-within:ring-red-100"
              : "border-[#e5e7eb] focus-within:border-[#1F0570] focus-within:ring-[#1F0570]/10"
          } flex flex-col justify-end gap-2.5 ${wrapClassName || ""}`}
        >
          <div className="flex items-center justify-between">
            {image && <div className=" rounded-md ml-2 ">{image}</div>}
            <input
              ref={field.ref}
              name={field.name}
              aria-invalid={hasError}
              type="text"
              placeholder={placeholder}
              className={`w-full border-none bg-transparent text-sm text-[#374151] outline-none placeholder:text-slate-400 ${inputClassName || ""}`}
              value={(field.value as string) ?? ""}
              onChange={(e) => field.onChange(e.target.value)}
              onBlur={field.onBlur}
              {...props}
            />{" "}
          </div>{" "}
          <ErrorMessage errors={errors} name={name} />
        </div>
      )}
    />
  );
};

export default Input;
